export default function formatTime(moment?: Moment | null, format?:string):string {


    if (!moment) return ''

    if (!format) {
        // format = gd.session.me.formatSettings.time
        // @ts-ignore
        format = gd.user.formatSettings?.time
    }

    return moment.format(format)

}

